import { motion } from "framer-motion";
import { Droplets, Scissors, Sparkles } from "lucide-react";
import { SERVICES, WHATSAPP_LINK } from "../../data/site";

const ICONS = [Droplets, Scissors, Sparkles];

export const Services = () => {
  return (
    <section id="servicos" data-testid="services-section" className="py-24 md:py-32 bg-ink text-white">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tightest leading-none">
            O que fazemos
          </h2>
          <p className="font-body text-[#a3a3a3] max-w-sm md:text-right">
            Serviços completos de estética animal, com horário marcado e muito carinho.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#2a2a2a] border border-[#2a2a2a]">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[idx];
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: idx * 0.12 }}
                data-testid={`service-card-${idx}`}
                className="group relative bg-[#0A0A0A] p-8 md:p-10 min-h-[340px] flex flex-col justify-between overflow-hidden"
              >
                <div className="absolute inset-0 bg-[#E20074] translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" />
                <div className="relative z-10 flex items-center justify-between">
                  <Icon size={34} strokeWidth={1.4} className="text-[#00B4D8] group-hover:text-white transition-colors duration-500" />
                  <span className="font-script text-3xl text-[#525252] group-hover:text-white/70 transition-colors duration-500">
                    {s.n}
                  </span>
                </div>
                <div className="relative z-10">
                  <h3 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight mb-3">
                    {s.title}
                  </h3>
                  <p className="font-body text-[#a3a3a3] group-hover:text-white/90 transition-colors duration-500 leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="services-cta"
            className="group inline-flex items-center gap-3 border border-white/30 hover:border-white text-white font-body font-medium pl-6 pr-2.5 py-2.5 rounded-full transition-colors"
          >
            Pedir orçamento no WhatsApp
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#00B4D8] text-[#0A0A0A] transition-transform duration-300 group-hover:rotate-45">
              →
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};
